// extracted by mini-css-extract-plugin
module.exports = {"logoutModal":"Sidebar_logoutModal__x5OzD"};